import { DadosBancarioConta } from "./dadosBancario/DadosBancarioConta";
import DadosBancarioPix from "./dadosBancario/DadosBancarioPix";
import DadosBancarioTipo, { EnumDadoBancarioTipo } from "./dadosBancario/DadosBancarioTipo";
import { TypePessoa } from "./Pessoa";

export interface DadosBancario {
    codigo: number;
    codPessoa: number;
    pessoa: TypePessoa | null;
    codTipo: number | EnumDadoBancarioTipo;
    tipo: DadosBancarioTipo | null;
    descricao: string | null;
    ativo: boolean;
    codOperador: number;
    dataCriacao: Date;
}

export function dadosBancarioToString(dados:DadosBancario) {
    let texto = " - ";
    if (dados.codTipo === EnumDadoBancarioTipo.ChavePix)
        texto = "Pix - " + (dados as DadosBancarioPix).chavePix;
    else if (dados.codTipo === EnumDadoBancarioTipo.Conta)
    {
        const conta = (dados as DadosBancarioConta);
        texto = `Conta bancária - Nº Ban. ${conta.banco?.codBanco ?? "-"} Ag. ${conta.numeroAgencia}${(conta.dacAgencia?.trim()?.length ?? 0) > 0 ? ("-" + conta.dacAgencia?.trim()) : ""} C.C. ${conta.numeroConta}${(conta.dacConta?.trim()?.length ?? 0) > 0 ? ("-" + conta.dacConta?.trim()) : ""}`
    }

    if ((dados.descricao?.replaceAll(" ", "")?.length ?? 0) > 0)
        texto += ` (${dados.descricao?.trim()})`;

    return texto;
}